
import React, { useState,useEffect } from 'react';
import './ExitRequestForm.css';
import image from "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from "./img/back.png";
import imageinfo from "./img/download-info.png";
import {EXITREQUEST,NOCUSERS} from "../../Pages/AppConstant"; 
import axios from "axios";
const ExitRequestForm = () => {
  useEffect(()=>{callnoclista()},[])
  const [formData, setFormData] = useState({
    
    reason: '',
    lastWorkingDay: '',
    comments: '',
    emailid: '',
    assetid:'',
    handover:'',
    admin:''
  });
  const [nocadminlist,setNocadminlist]=useState([])
  const [nocitlist,setNocitlist]=useState([])
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Exit Request Submitted:', formData);
    // Add API call or backend integration here
  };
  const redirectToLogin = () => {
        window.location.href = "/login"
    }
    const redirectTodashboard = () => {
        window.location.href = "/landingPage"
    }

   const isAlpha = checkvalue => /^[a-zA-Z]*$/.test(checkvalue)
    const handleChangeasset=(e)=>{
        let checkvalue =e.target.value
        if(e.target.value.length===11){
            let strRegex = new RegExp(/^[A-Za-z]+$/i);
            let result1 = strRegex.test(checkvalue);
            let strRegex2 = new RegExp(/^[0-9]+$/i);
            let result2 = strRegex2.test(checkvalue);
            if(result1 || result2===true){
                setFormData({ ...formData, [e.target.name]: e.target.value });
                alert("Should contain alphanumeric")
            }else{
               setFormData({ ...formData, [e.target.name]: e.target.value });
            }
           
        }else{
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
        
    }
    const callnoclista=()=>{
                   axios({
                       method: "get",
                       url: NOCUSERS,
                       withCredentials: false,
                       headers: {
                         "Content-Type": "application/x-www-form-urlencoded",
                         "Access-Control-Allow-Origin": "*",
                       }
                     })
                       .then((response) => {
                        console.log(response)
                     
                        const result = response.data.data.reduce(
                            (acc, item) => {
                            if (item.deparment === "IT") {
                            acc.it.push(item);
                            } else if (item.deparment === "Admin") {
                            acc.admin.push(item);
                            }
                            return acc;
                            },
                            { it: [], admin: [] }
                            );
                            // console.log(result.it)
                            // console.log(result.admin)
                           setNocitlist(result.it);
                           setNocadminlist(result.admin);
                       })
                       .catch((error) => {
                         console.error(error);
                       });
               }
  const callsubmitfn=()=>{
    formData.switch_code=localStorage.getItem('empid');
    var admindata = formData.admin.split("|")
    formData.admin =admindata[0] 
    formData.adminemailid =  admindata[1]
     var itdata = formData.handover.split("|")
    formData.handover =itdata[0] 
    formData.itemailid =  itdata[1]
    formData.requests="Initiated"
    // if(formData.handover=="TL_0003"){
    //   formData.itemailid="TML_parthiban@switchmobilityev.com"
    // }else if(formData.handover=="TL_0004"){
    //   formData.itemailid="TML_muniyapillaig@switchmobilityev.com"
    // }else if(formData.handover=="300458"){
    //   formData.itemailid="sathish.m@switchmobilityev.com"
    // }else if(formData.handover=="LHR_0191"){
    //   formData.itemailid="Lead_Pavankumar@switchmobilityev.com"
    // }
    //  if(formData.admin=="HLF0031"){
    //   formData.adminemailid="hlf_chandran.a@switchmobilityev.com"
    // }else if(formData.admin=="LHR_0025"){
    //   formData.adminemailid="Lead_raguvaran.r@switchmobilityev.com"
    // }else if(formData.admin=="300440"){
    //   formData.adminemailid="diwakar.B@switchmobilityev.com"
    // }else if(formData.admin=="LHR_0136"){
    //   formData.adminemailid="Lead_sakthiravi@switchmobilityev.com"
    // }
    axios({
            method: "post",
            url: EXITREQUEST,
            headers: { "Content-Type": "multipart/form-data" },
            data: formData,
          })
            .then((response) => {
              alert(response.data);
            })
            .catch((error) => {
              console.error(error);
            });
    console.log(formData)
  }
  return (
   <div className="bg_set_usb">   
         <div className="switch" >
                    <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/> 
                    <img className="switch-img" src={image}/>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/><br/> 
    <div className="exit-form-container">
      <h2>Employee Exit Request</h2>
      <form onSubmit={handleSubmit} className="exit-form">     
    <label>Switch Email ID:</label>
        <input type="email" name="emailid" placeholder="Switch Email ID"value={formData.emailid} onChange={handleChange} required />
       <div><div className="designasset"><label>Assert ID:</label></div><div className="infodesign" title='To get the asset ID, open the Command Prompt and type " hostname "'><img  style={{width: "10%"}}onClick={redirectTodashboard} src={imageinfo}/></div></div>
        <input type="Text" name="assetid" placeholder="Asset ID" value={formData.assetid} maxlength='11' onChange={handleChangeasset} required />   
        <label>Asset Handover :</label>
        <select name="handover" value={formData.handover} onChange={handleChange} required>
          <option value="">Select </option>
           {nocitlist.map((option, index) => {
                                        return (
                                            <option value={`${option.empid}|${option.emailid}`  } key={index}>
                                                {option.name}
                                            </option>
                                        );
                                    })}
                 
        </select>
          <label>Select Admin :</label>
        <select name="admin" value={formData.admin} onChange={handleChange} required>
           <option value="">Select </option>
          {nocadminlist.map((option, index) => {
                                        return (
                                            <option value={`${option.empid}|${option.emailid}`} key={index}>
                                                {option.name}
                                            </option>
                                        );
                                    })}
                 
        </select>
        <label>Reason for Exit:</label>
        <select name="reason" value={formData.reason} onChange={handleChange} required>
          <option value="">Select Reason</option>
          <option value="Personal">Personal</option>
          <option value="Career Growth">Career Growth</option>
          <option value="Relocation">Relocation</option>
          <option value="Other">Other</option>
        </select>

        {/* <label>Last Working Day:</label>
        <input type="date" name="lastWorkingDay" value={formData.lastWorkingDay} onChange={handleChange} required /> */}

        <label>Comments:</label>
        <textarea name="comments" value={formData.comments} onChange={handleChange} />

        <button type="submit" onClick={()=>callsubmitfn()}>Submit Request</button>
      </form>
    </div>
    </div>
  );
};

export default ExitRequestForm;
